import script from "./AlbumForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumForm.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumForm.vue?vue&type=style&index=0&id=3aa7298c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa7298c"]])

export default __exports__